export enum OnboardingStep {
  Landing = 'landing',
  VerifyPhone = 'verifyPhone',
  AddVehicle = 'addVehicle',
  AddPayment = 'addPayment',
  AddEmail = 'addEmail',
  ReviewSubscription = 'reviewSubscription',
  Success = 'success',
}
